import { render, staticRenderFns } from "./referansmizan.vue?vue&type=template&id=7a999068&scoped=true"
import script from "./referansmizan.vue?vue&type=script&lang=js"
export * from "./referansmizan.vue?vue&type=script&lang=js"
import style0 from "./referansmizan.vue?vue&type=style&index=0&id=7a999068&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a999068",
  null
  
)

export default component.exports